import React from 'react';
import * as people from '../data/people.js';

function AutocompleteDropdown({
  isOpen,
  filter,
  onSelect,
  inputRef,
  selectedIndex,
}) {
  if (!isOpen) return null;

  // Get all people and filter them based on the input
  const allPeople = Object.values(people);
  const filteredPeople = allPeople.filter((person) =>
    person.name.toLowerCase().startsWith(filter.toLowerCase()),
  );

  return (
    <div
      className="absolute z-10 mt-2 max-h-60 w-full overflow-y-auto rounded-xl border border-white/20 bg-zinc-900/70 shadow-2xl backdrop-blur-xl"
      style={{
        top: '100%',
        left: 0,
      }}
    >
      {filteredPeople.length > 0 ? (
        filteredPeople.map((person, index) => (
          <div
            key={person.name}
            onClick={() => onSelect(person.name)}
            className={`flex cursor-pointer items-center gap-3 border-b border-white/10 p-2 transition-all duration-200 last:border-b-0 sm:p-3 ${
              index === selectedIndex
                ? 'bg-white/15 backdrop-blur-md'
                : 'hover:bg-white/10'
            }`}
          >
            <img
              src={`/profile-pics/${person.name.toLowerCase()}.png`}
              alt={person.name}
              className="h-6 min-h-6 w-6 min-w-6 flex-shrink-0 rounded-lg object-cover sm:h-8 sm:min-h-8 sm:w-8 sm:min-w-8"
            />
            <span className="text-sm font-medium text-white sm:text-base">
              {person.name}
            </span>
          </div>
        ))
      ) : (
        <div className="p-3 text-center text-sm font-medium text-white/60">
          No matches found
        </div>
      )}
    </div>
  );
}

export default AutocompleteDropdown;
